import React from "react";

import { Anchor } from "@mantine/core";

import { staticLinks } from "@config/staticLinks";

import { MightierCheckbox } from "@components/MightierCheckbox/index";
import { Trans, useTranslation } from "react-i18next";

import type { AccountActivateForm } from "src/services/accountActivation/accountActivationTypes";

import type { MightierSupportedLanguage } from "@neuromotion-inc/mightier-ts-sdk";

interface LegalUrls {
  termsOfServiceUrl: string;
  privacyPolicyUrl: string;
}

export const useLegalUrls = (): LegalUrls => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language as MightierSupportedLanguage;
  return {
    termsOfServiceUrl: staticLinks.termsOfService(currentLanguage),
    privacyPolicyUrl: staticLinks.privacyPolicy(currentLanguage),
  };
};

export const TermsOfService: React.FC<{
  form: AccountActivateForm;
}> = ({ form }) => {
  const { t } = useTranslation();
  const { termsOfServiceUrl, privacyPolicyUrl } = useLegalUrls();

  return (
    <MightierCheckbox
      {...form.getInputProps("yesTermsAndPolicy", { type: "checkbox" })}
      label={
        <Trans
          i18nKey="startPage.yesTermsAndPolicy"
          components={{
            1: (
              <Anchor
                href={termsOfServiceUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontSize: "inherit" }}
              >
                {t("startPage.termsOfService")}
              </Anchor>
            ),
            2: (
              <Anchor
                href={privacyPolicyUrl}
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontSize: "inherit" }}
              >
                {t("startPage.privacyPolicy")}
              </Anchor>
            ),
          }}
        />
      }
      data-testid="terms-of-service-checkbox"
    />
  );
};
